import { configureStore } from '@reduxjs/toolkit';
import traceabilityReducer from 'Components/Traceability/traceabilitySlice';
import clientInfoReducer from 'Components/Recovery/RecoveryView/clientInfoSlice';
import tecdocSliceReducer from 'Components/ExternSearch/tecdocSlice';
import appReducer from './appSlice';

const store = configureStore({
  reducer: {
    traceability: traceabilityReducer,
    app: appReducer,
    clientInfo: clientInfoReducer,
    tecdoc: tecdocSliceReducer,
  },
});

export default store;
